export interface IUser {
  userId: string;
  userName: string;
  departments: IDepartment[];
  selectedDepartment?: string;
  defaultDepartment?: string;
}

export interface IDepartment {
  department: string;
  theme: string;
  isAdmin: boolean;
  friendlyName: string;
  clientViewerEnabled: boolean;
  siteFeatureEnabled: boolean;
}

export class User implements IUser {
  userId = '';
  userName = '';
  departments: IDepartment[] = [];
  selectedDepartment? = '';
  defaultDepartment? = '';

  constructor(user?: IUser) {
    Object.assign(this, user);

    if (!user?.selectedDepartment) {
      this.selectedDepartment = this.getUserSelectedDepartment(this.getUserDefaultDepartment());
    } else {
      this.selectedDepartment = user.selectedDepartment;
    }

    if (!user?.defaultDepartment) {
      this.defaultDepartment = this.getUserDefaultDepartment();
    } else {
      this.defaultDepartment = user.defaultDepartment;
    }
  }

  getUserDefaultDepartment(): string {
    return this.defaultDepartment ? this.defaultDepartment : (this.departments && this.departments.length > 0 ? this.departments[0].department : '');
  }

  getUserSelectedDepartment(departmentName: string): string {
    return this.departments.find(
      (d: IDepartment) => d.department === departmentName
    )?.department || '';
  }

  getUserTheme(selectedDepartment: string): string {
    return this.departments.find(
      (d: IDepartment) => d.department === selectedDepartment
    )?.theme || '';
  }

  isUserAdmin(selectedDepartment: string): boolean {
    return this.departments.find(
      (d: IDepartment) => d.department === selectedDepartment
    )?.isAdmin || false;
  }

  isClientViewerEnabled(selectedDepartment: string): boolean {
    return this.departments.find(
      (d: IDepartment) => d.department === selectedDepartment
    )?.clientViewerEnabled || false;
  }

  isSiteFeatureEnabled(selectedDepartment: string): boolean {
    return this.departments.find(
      (d: IDepartment) => d.department === selectedDepartment
    )?.siteFeatureEnabled || false;
  }
}
